import { useStore } from "../state/MobxContext";
// import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Container } from '@material-ui/core';
import Box from '@mui/material/Box';
import TopBar from "./Main/TopBar";
import UserBar from "./Main/UserBar";
import PmgBar from "./Main/PmgBar";
import MiningBar from "./Main/MiningBar";
import CloverMissionBar from "./Main/CloverMissionBar";
import MissionPmgBar from "./Main/MissionPmgBar";
import { makeStyles, useMediaQuery } from "@material-ui/core";
import SignUpDialog from "./Dialog/SignUpDialog";
import Walletinformation from "./Dialog/Walletinformation";
import CoinSend from "./Dialog/CoinSend";
import { useEffect, useState } from "react";
import PmgImage from "../pages/Main/image/Pmg_big.png";
import CloverImage from '../pages/Main/image/Clover_big.png';
import CagImage from '../pages/Main/image/cag_big.png';
import GolfImage from '../pages/Main/image/GP_big.jpg'; //골프 업데이트 후 풀어
import DBCoinTransfer from "./Dialog/DBCoinTransfer";
import UserProfile from "./Dialog/UserProfile";
import Mining from "./Dialog/Mining";
import Verify from "./Dialog/Verify";
import AuthenticationCheck from "./Dialog/AuthenticationCheck";
import WalletBar from "./Main/WalletBar";
import GameMission from "./Dialog/GameMission";
import CloverSale from "./Dialog/CloverSale";
import CloverMarket from "./Dialog/CloverMarket/CloverMarket";
import useGeoLocation from "react-ipgeolocation";
import JsBarcode from "jsbarcode";
import MarketProductPurchase from "./Dialog/CloverMarket/MarketProductPurchase/MarketProductPurchase";
import CoinExchangePropose from "./Dialog/CoinExchange/CoinExchangePropose";
import MerketCouponitem from "./Dialog/CloverMarket/MarketCouponitem/MarketCouponitem";
import CloverLockPage from "./Dialog/CloverLockCoin/CloverLockPage";
// import { toJS } from "mobx";





const Home = () => {


    const [imageUrl, setImageUrl] = useState('');

    const { CoinStore } = useStore();
    const { loginStore } = useStore();
    const { MissionStore } = useStore();
    // const { MiningStore } = useStore();
    const { SaleStore } = useStore();
    // const { UserProfileStore } = useStore();







    const useStyles = makeStyles((theme) => ({
        HomePc: {
            fixed: true,
            minWidth: "full",
            height: 'auto',
            Width: '1200vw',
            overflowX: "hidden",
            overflowY: "hidden",
            p: 0
        },
        HomeLgSize: {
            disableGutters: true,
            width: '960vw',
            height: 'auto',
            margin: '0',
            padding: '0',
            overflowX: "hidden",
            overflowY: "hidden"
        },
        HomeMobile: {
            disableGutters: true,
            width: '100vw',
            height: 'auto',
            margin: '0',
            padding: '0',
            overflowX: "hidden",
            overflowY: "hidden"
        },


    }));







    const location = useGeoLocation();




    const start = CoinStore.WalletUpdateStart;
    const member_no = loginStore.loginState.member_no;

    useEffect(() => {
        const start = CoinStore.WalletUpdateStart;
        const member_no = loginStore.loginState.member_no;

        if (member_no !== undefined || member_no !== null || member_no !== "") {
            if (start === true) {
                let timerId = setInterval(() => CoinStore.WalletUpdate(), 600000);

                setTimeout(() => { clearInterval(timerId); }, 3600000);
            }
        }
        // eslint-disable-next-line
    }, [start, member_no])




    let epin = String(SaleStore.sale_test_data);
    // let epin = String(12345678123);


    useEffect(() => {// 바코드 이미지 생성
        if (epin !== undefined && epin !== null && epin !== "") {
            const canvas = document.createElement('canvas')
            JsBarcode(canvas, epin, { height: 50, displayValue: true, format: "CODE128", fontSize: 15 })
            setImageUrl(canvas.toDataURL('image/png'))
        }
    }, [epin]);





    const WalletValue = CoinStore.WalletInput;
    const StandValue = CoinStore.StandInput;

    useEffect(() => {// 지갑 보내는거 변경 하면 초기화
        CoinStore.errSendButtonChange();
        // eslint-disable-next-line
    }, [WalletValue, StandValue])

    // useEffect(() => {//지갑 불러오기
    //     const Wallet = CoinStore.WalletData.address;
    //     // console.log('Wallet ', Wallet);
    //     if( AuthCode != undefined || null ||  "" ){
    //         if (Wallet == undefined || Wallet == null || Wallet == "") {
    //             console.log('getwallet',AuthCode);
    //             CoinStore.getWalletData('walletOpen');
    //             //   console.log("getWalletDataOK");
    //         }
    //     }
    //     // eslint-disable-next-line
    // }, [Wallet,AuthCode])



    // let BannerCheck = MissionStore.BannerCheck;
    let ObjectArray = [CagImage, CloverImage, PmgImage, GolfImage] //골프
    // let ObjectArray = [CagImage, CloverImage, PmgImage]
    let ObjectCount = 0;

    useEffect(() => {
        // loginStore.getipChack("Login");
        setInterval(() => { ShowImageRotate(); }, 5000);
        // setInterval(() => { TestTimeRefresh(); }, 10000);// 시간마다 새로고침 테스트용

        // eslint-disable-next-line
    }, [ObjectCount])


    function ShowImageRotate() {//이미지 바꿈
        const objectCount = ObjectCount;
        if (objectCount === 0) {
            (document.getElementById("image_id") || {}).src = ObjectArray[ObjectCount];
            MissionStore.BannerCheck = "Cag";
            // (document.getElementById("image_id_Mission_One") || {} ).src = ObjectArray[ObjectCount];
            // (document.getElementById("image_id_Mission_Two") || {} ).src = ObjectArray[ObjectCount];
            ObjectCount = ObjectCount + 1;
        }
        else if (objectCount === 1) {
            (document.getElementById("image_id") || {}).src = ObjectArray[ObjectCount];
            MissionStore.BannerCheck = "Clover";
            ObjectCount = ObjectCount + 1;
        }
        else if (objectCount === 2) {
            (document.getElementById("image_id") || {}).src = ObjectArray[ObjectCount];
            MissionStore.BannerCheck = "Pmg";
            ObjectCount = ObjectCount + 1;
        }
        else if (objectCount === 3) {// 골프
            (document.getElementById("image_id") || {}).src = ObjectArray[ObjectCount];
            MissionStore.BannerCheck = "Golf";
            ObjectCount = ObjectCount + 1;
        }
        else {
            ObjectCount = 0;
        }
    }



    // function TestTimeRefresh() {//이미지 바꿈
    //     window.location.reload();
    // }

    localStorage.IsMainPage = loginStore.isMainPage;
    localStorage.IsRecommenderPage = loginStore.isRecommenderPage;
    useEffect(() => {// 새로고침시 UserBar,MiningBar 유지
        if (loginStore.isMainPage) {
            window.addEventListener("beforeunload", loginStore.setIsMainPage(true));
        }
        else {
        }
        if (loginStore.isRecommenderPage) {
            window.addEventListener("beforeunload", loginStore.setIsRecommenderPage(true));
        }
        else {
            // window.addEventListener("beforeunload", loginStore.setIsRecommenderPage(false));
        }
        // eslint-disable-next-line
    }, []);

    window.onpopstate = function (event) {//모바일 뒤로가기 
        loginStore.setDialogClose("AllFalse");
    }


    useEffect(() => {//해외 세팅

        if (location.country) {
            loginStore.getipChack(location.country);
            // loginStore.getipChack("US");// Test
            // if(member_no) {
            // }
            // SaleStore.getCloverExchange("homeTest"); // Test sale_clover
        }

        // eslint-disable-next-line
    }, [location.country]);






    const isMobile = useMediaQuery("(max-width: 600px)");
    const isLg = useMediaQuery("(max-width: 1280px)");
    const classes = useStyles();
    const isRecommenderPage = loginStore.isRecommenderPage;
    const isMainPage = loginStore.isMainPage;

    
    // let TableTest = toJS(SaleStore.ProductList);// 마켓테스트
    // console.log(TableTest);// 마켓테스트


    // const downloadFile = (url) => {
    //     console.log(url);
    //     url = testfile ;

    //     fetch(url, { method: 'GET' })
    //         .then((res) => {
    //             return res.blob();
    //         })
    //         .then((blob) => {
    //             const url = window.URL.createObjectURL(blob);
    //             const a = document.createElement('a');
    //             a.href = url;
    //             a.download = "Stand";
    //             document.body.appendChild(a);
    //             a.click();
    //             setTimeout((_) => {
    //                 window.URL.revokeObjectURL(url);
    //             }, 60000);
    //             a.remove();
    //             // setOpen(false);
    //         })
    //         .catch((err) => {
    //             console.error('err: ', err);
    //         });
    // };

    return (
        <div className="home" >
            <Container style={{ paddingLeft: 0, paddingRight: 0, }} className={isMobile ? classes.HomeMobile : classes.HomePc} >
                <SignUpDialog />
                <Walletinformation />
                <CoinSend />
                <DBCoinTransfer />
                <UserProfile />
                <Verify />
                <AuthenticationCheck />
                <Mining />
                <GameMission />
                <CloverSale />
                <CloverMarket />
                <MarketProductPurchase />
                <MerketCouponitem />
                <CoinExchangePropose />
                <CloverLockPage />
                <Box sx={isMobile ? { bgcolor: '#212121', height: '135vh', maxWidth: 'fullscreen', minWidth: '320px' }
                    : isLg ? { bgcolor: '#212121', height: '135vh', maxWidth: 'fullscreen' }
                        : { bgcolor: '#212121', height: '175vh', maxWidth: 'fullscreen', }} >
                    <div >
                        <TopBar />
                    </div >
                    <Container >
                        {isMainPage === true ?
                            <div style={isMobile ? { marginTop: "10px", marginBottom: "10px" } : { marginTop: "20px", marginBottom: "20px" }}>
                                <UserBar />
                                {/* <button onClick={(e) => { CoinStore.getMemberLockTokenData("IN") }}>test</button>
                                <button onClick={(e) => { loginStore.setDialogOpen("CloverLock") }}>PageTest</button> */}

                                {/* 마켓 테스트 <button onClick={(e) => { SaleStore.getMarketData() }}>test</button>
                                <button onClick={(e) => { SaleStore.getMarketStatus() }}>test2</button>
                                <button onClick={(e) => { SaleStore.getMarketPLData() }}>test3</button>

                                <div>{TableTest.length !== 0 ? <img src={TableTest[0].image} /> : <div></div>}</div>
                                <div>{TableTest.length !== 0 ? <img src={TableTest[1].image} /> : <div></div>}</div>

                                <div>{imageUrl && <img src={imageUrl} />}</div> */}
                            </div>
                            :
                            <div>
                                <br />
                            </div>
                        }
                        <div>
                            <PmgBar />
                        </div>
                        {isRecommenderPage === true ?
                            <div style={{ marginBottom: "10px" }}  >
                                <WalletBar />
                                <MiningBar />
                            </div>
                            :
                            <div>
                                <br />
                            </div>
                        }
                        <div>
                            <CloverMissionBar />
                        </div>
                        <div>
                            <MissionPmgBar />
                        </div>
                    </Container>
                </Box>
                {/* Home

                <div>{loginStore.loginState.member_nickname}, </div>
                <div>${process.env.REACT_APP_PROFILE_IMAGE_SERVER}${loginStore.loginState.profile_image}</div>
                <div>
                    {loginStore.loginState.profile_image ?
                        <img src={`${process.env.REACT_APP_PROFILE_IMAGE_SERVER}${loginStore.loginState.profile_image}`} />
                        :
                        `not found image`
                    }
                </div>
                <button onClick={e=>{
                    loginStore.logOut();
                }}></button> */}
            </Container >
        </div>
    );
}

export default observer(Home);